import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-display-field',
  imports: [TranslateModule],
  templateUrl: './display-field.component.html',
  styleUrl: './display-field.component.scss',
})
export class DisplayFieldComponent {
  label = input.required<string>();
  displayText = input.required<string>();
}
